import { PropsWithChildren } from 'react';
import { Stack } from '@optimus-web/core';
import { GuideLinkButton } from '../navigation';
import { ModalWrapper, NewModalBodyWrapper } from './ModalWrapper';
import { PageHeader, PageHeaderProps } from './PageHeader/PageHeader';

export type PageLayoutProps = {
    padded?: boolean;
    guideLink?: string;
} & PageHeaderProps;

export const PageLayout = ({
    children,
    padded,
    guideLink,
    actions = null,
    ...other
}: PropsWithChildren<PageLayoutProps>) => {
    const pageHeaderActions = (
        <Stack spacing="100">
            {actions}
            {guideLink != null && <GuideLinkButton variant="tertiary" size="medium" guideLink={guideLink} />}
        </Stack>
    );

    return (
        <ModalWrapper>
            <PageHeader {...other} actions={pageHeaderActions} />
            <NewModalBodyWrapper padded={padded}>{children}</NewModalBodyWrapper>
        </ModalWrapper>
    );
};
